import { FC, useCallback, useEffect, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { DateSelector } from '../widgets/DateSelector'

type Props = {
  dateStart: Date | null    
  dateEnd: Date | null
  doClose: Function
  onSubmit: Function
  titleText?: string
  subTitleText?: string
  requireSelect?: boolean
}


const DateRangeSelectorDialog: FC<Props> = ({dateStart, dateEnd, doClose, onSubmit, titleText, subTitleText, requireSelect = true}) => {
  
  const [ start_dt, setStartDt ] = useState<Date | null>(null);
  const [ end_dt, setEndDt ] = useState<Date | null>(null);


  const onChangeStartDate = useCallback((dt: any) => {
    setStartDt(dt);                                        
  }, [setStartDt]);

  const onChangeEndDate = useCallback((dt: any) => {
    setEndDt(dt);                                        
  }, [setEndDt]);

  useEffect(() => {
    if (! dateStart) return;
    setStartDt(dateStart);
  }, [dateStart])

  useEffect(() => {
    if (! dateEnd) return;
    setEndDt(dateEnd);
  }, [dateEnd])

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
  <>
  <div
    className='modal fade show d-block'
    id='kt_modal_date_range_selector'
    role='dialog'
    tabIndex={-1}
    aria-modal='true'
  >
    <div className='modal-dialog modal-dialog-centered mw-400px'>
      <div className='modal-content'>
        <div className='modal-header'>
          <div>
            <h2 className='fw-bolder'>
              { titleText ? titleText : 'Select Date Range'}
            </h2>                        
          </div>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-producttypes-modal-action='close'
            style={{cursor: 'pointer'}}
            onClick={() => doClose()}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
          </div>
        </div>                
        <div
          className='d-flex flex-column scroll-y p-7'
          id='kt_date_range_selector_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'                        
          data-kt-scroll-offset='300px'
        >
          <div className="row mb-4">
            <div className="col-6">
              <div>
                <label className="fs-7">Start Date: </label>
                <DateSelector
                  placeholderText="Set Start Date"
                  className='form-control form-control-sm form-control-solid'
                  selected={start_dt}
                  onChange={onChangeStartDate}
                  dateFormat="LL"
                />        
              </div>
            </div>
            <div className="col-6">
              <div>
                <label className="fs-7">End Date: </label>
                <DateSelector
                  placeholderText="Set End Date"
                  className='form-control form-control-sm form-control-solid'
                  selected={end_dt}
                  onChange={onChangeEndDate}
                  dateFormat="LL"
                />        
              </div>
            </div>
          </div>

          <div className='text-center mt-6'>
            <button
              type='reset'
              onClick={()=> { doClose()}}
              className='btn btn-light me-3'
              data-kt-producttypes-modal-action='cancel'                                
            >
              Discard
            </button>

            <button
              type='submit'
              className='btn btn-primary'
              data-kt-producttypes-modal-action='submit'
              disabled={! (requireSelect && start_dt && end_dt)}
              onClick={() => {
                onSubmit(start_dt, end_dt);
              }}
            >
              <span className='indicator-label'>Confirm</span>                                
            </button>
          </div>
        </div>
      </div>            
    </div>
  </div>
  <div className='modal-backdrop fade show'></div>
  </>
  )
}

export {DateRangeSelectorDialog}
